import { useEffect } from 'react';
import { authToken } from '../../storage/authToken';
import { useCustomSelectors } from '../../services/selectors/allSelectors';
import { connectRealtimeDemo } from '../../services/realtime/realtimeSocket';
import { toast } from 'react-toastify';

const realtimeNotificationMessages = {
	'mobile-refill-request-created': {
		type: 'refill',
		title: 'New refill request',
		description: 'A patient sent a refill request from the mobile app.',
	},
	'mobile-prescription-order-created': (payload) => (
		payload?.order_type === 'transfer_prescription'
			? {
				type: 'transfer',
				title: 'New transfer prescription',
				description: 'A patient submitted a transfer prescription request.',
			}
			: {
				type: 'prescription',
				title: 'New prescription',
				description: 'A patient uploaded a new prescription request.',
			}
	),
};

const RealtimeRequestToast = ({ notification }) => (
	<div className="mobile-request-toast-content">
		<div className={`mobile-request-toast-icon mobile-request-toast-icon--${notification.type}`}>
			<span />
		</div>
		<div className="mobile-request-toast-copy">
			<p className="mobile-request-toast-title">{notification.title}</p>
			<p className="mobile-request-toast-description">{notification.description}</p>
		</div>
	</div>
);

const RealtimeDemoManager = () => {
	const token = authToken();
	const { pharmacyId, loginUserID } = useCustomSelectors();

	useEffect(() => {
		if (!token || !pharmacyId || !loginUserID) {
			return undefined;
		}

		let cleanup = null;
		let cancelled = false;

		connectRealtimeDemo({
			onStatus: (status) => {
				// console.info('[Realtime]', status);
			},
			onEvent: ({ event, payload }) => {
				// console.info(`[Realtime] ${event}`, payload);
				const notificationConfig = realtimeNotificationMessages[event];
				const notification = typeof notificationConfig === 'function'
					? notificationConfig(payload)
					: notificationConfig;

				if (notification) {
					toast.info(<RealtimeRequestToast notification={notification} />, {
						autoClose: 4500,
						className: 'mobile-request-toast',
						bodyClassName: 'mobile-request-toast-body',
						icon: false,
					});
				}
			},
		})
			.then((closeConnection) => {
				if (cancelled) {
					closeConnection();
					return;
				}

				cleanup = closeConnection;
			})
			.catch((error) => {
				// console.error('[Realtime] connection failed', error);
			});

		return () => {
			cancelled = true;
			if (cleanup) {
				cleanup();
			}
		};
	}, [loginUserID, pharmacyId, token]);

	return null;
};

export default RealtimeDemoManager;
